import { VisitorPayload } from "../types/visitor";
import { postRequest } from "../services/api";

const API_URL = "/visitors/track";

export const trackVisitor = async (data: VisitorPayload): Promise<void> => {
  try {
    const payload: VisitorPayload = {
      ...data,
      device: /Mobi/.test(navigator.userAgent) ? "Mobile" : "Desktop",
      location: Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    console.log("VISITOR PAYLOAD:", payload);

    await postRequest(API_URL, payload);
  } catch (err) {
    console.error("Tracking error:", err);
  }
};